import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import ReceiptsPage from './ReceiptsPage';
import InvoicesPage from './InvoicesPage';
import ChangePasswordPage from './ChangePasswordPage';
import Login from './Login';
import NavBar from './NavBar';
import ServicesPage from './ServicesPage'; // Import the Services Report page
import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [org, setOrg] =useState(localStorage.getItem('org'));

  return (
    <Router>
      <div>
        <NavBar token={token} onLogout={() => {
          localStorage.removeItem('token');
          localStorage.removeItem('org');
          setToken(null);
          setOrg("Rahman Multispeciality Hospital");
        }} />
        <div className="container mt-5">
          <Routes>
            <Route path="/login" element={!token ? <Login onLogin={setToken} /> : <Navigate to="/dashboard" />} />
            <Route path="/dashboard" element={token ? <Dashboard /> : <Navigate to="/login" />} />
            <Route path="/receipts" element={token ? <ReceiptsPage token={token} /> : <Navigate to="/login" />} />
            <Route path="/invoices" element={token ? <InvoicesPage token={token} /> : <Navigate to="/login" />} />
            <Route path="/change-password" element={token ? <ChangePasswordPage token={token} /> : <Navigate to="/login" />} />
            <Route path="/services" element={token ? <ServicesPage token={token} /> : <Navigate to="/login" />} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
